import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Global scroll restoration for the SPA.
 *
 * PUSH / REPLACE  -> scroll to top (unless a hash anchor is present).
 * POP             -> restore the previously saved scroll position for
 *                    that history entry (works via location.key).
 *
 * Preserves intentional in-page anchor behaviour: when `location.hash`
 * is set, we do NOT override — the browser/router owns that scroll.
 */
const K = "scroll:";

export default function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();
  const navType = useNavigationType();
  const prevKey = useRef(key);

  useEffect(() => {
    // Save the *outgoing* location's scrollY before we leave it.
    try {
      sessionStorage.setItem(K + prevKey.current, String(window.scrollY));
    } catch (e) { /* sessionStorage may be unavailable */ }
    prevKey.current = key;

    if (hash) return; // let the browser jump to the anchor

    if (navType === "POP") {
      const saved = parseInt(sessionStorage.getItem(K + key) || "0", 10);
      window.scrollTo({ top: saved || 0, left: 0, behavior: "auto" });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, hash, navType, pathname, search]);

  return null;
}
